import { Box, Typography, Link, Divider } from "@mui/material";
import { FayeAppBar } from "components/layout/NavigationLayout";
import UnpaidMembershipUpsell from "components/member/UnpaidMembershipUpsell";
import useIsMobile from "components/hooks/useIsMobile";

export default () => {
  const isMobile = useIsMobile();
  return (
    <>
      <FayeAppBar />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "98px", // 50px AppBar + 48px spacing
          paddingBottom: "48px",
          paddingX: "24px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            maxWidth: "600px",
            marginBottom: !isMobile ? "32px" : undefined,
          }}
        >
          <Typography
            variant="h2"
            sx={{
              marginBottom: "16px",
              textAlign: "center",
            }}
          >
            Your preview has ended
          </Typography>
          <Typography
            variant="body"
            sx={{
              textAlign: "center",
              color: "text.secondary",
            }}
          >
            We hope you enjoyed your time with Faye! To continue using our
            services, please select a membership plan below.
          </Typography>
        </Box>
        {isMobile && <Divider sx={{ width: "100%", margin: "22px 0" }} />}
        <Box sx={{ width: "100%", maxWidth: "800px" }}>
          <UnpaidMembershipUpsell useContinueText={true} hideTitle={true} />
        </Box>
        <Typography
          variant="bodySmall"
          sx={{
            marginTop: "32px",
            textAlign: "center",
            color: "text.secondary",
          }}
        >
          Have questions? Contact us at{" "}
          <Link
            href="mailto:support@findfaye.com"
            sx={{
              color: "primary.main",
              textDecoration: "none",
            }}
          >
            support@findfaye.com
          </Link>
        </Typography>
      </Box>
    </>
  );
};
